/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { GeoLocationRecordType, PostGeoLocationResponseType } from "~/features/dashboard/types";

const transformToGeoLocation = (apiData: PostGeoLocationResponseType): Record<string, GeoLocationRecordType> => {
  const transformed: Record<string, GeoLocationRecordType> = {};

  apiData.data.body.forEach((country) => {
    transformed[country.ctry] = {
      countryCode: country.ctry,
      netRevenue: Number(country.netrevenue),
    };
  });

  return transformed;
};

export default transformToGeoLocation;
